export const companyOverviewConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getOutletList_request: "getOutletList_request",
        getOutletList_success: "getOutletList_success",
        getOutletList_failure: "getOutletList_failure",

        getLicenseList_request: "getLicenseList_request",
        getLicenseList_success: "getLicenseList_success",
        getLicenseList_failure: "getLicenseList_failure",

        getPackageList_request: "getPackageList_request",
        getPackageList_success: "getPackageList_success",
        getPackageList_failure: "getPackageList_failure",

        addOutlet_request: "addOutlet_request",
        addOutlet_success: "addOutlet_success",
        addOutlet_failure: "addOutlet_failure",

        addLicense_request: "addLicense_request",
        addLicense_success: "addLicense_success",
        addLicense_failure: "addLicense_failure",

        resetLicense_request: "resetLicense_request",
        resetLicense_success: "resetLicense_success",
        resetLicense_failure: "resetLicense_failure",

        deleteLicense_request: "deleteLicense_request",
        deleteLicense_success: "deleteLicense_success",
        deleteLicense_failure: "deleteLicense_failure",

        updateLicenseRemark_request: "updateLicenseRemark_request",
        updateLicenseRemark_success: "updateLicenseRemark_success",
        updateLicenseRemark_failure: "updateLicenseRemark_failure",

        changeCompanyStatus_request: "changeCompanyStatus_request",
        changeCompanyStatus_success: "changeCompanyStatus_success",
        changeCompanyStatus_failure: "changeCompanyStatus_failure",

        suspendCOM_request: "suspendCOM_request",
        suspendCOM_success: "suspendCOM_success",
        suspendCOM_failure: "suspendCOM_failure"
    }

    let obj_formatted = {};
    let domain = "distributorPortal.companyOverview/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}